import React from "react";

// Roxo + coral, para o painel branco do formulário.
import brindemeLogo from "../../assets/images/svgs/logo.svg";

export const AuthTemplate = ({ children }) => {
    return (
        <main id="auth">
            <section className="login-panel">
                <div className="login-brand">
                    <img id="logo" src={brindemeLogo} alt="Brinde.me" />
                </div>
                <div className="login-content">
                    {children}
                </div>
                <footer className="login-footer">
                    <a href="https://brinde.me" target="_blank" rel="noreferrer">
                        Plataforma Brinde.me
                    </a>
                </footer>
            </section>

            {/* Fundo (malha quadriculada + cunha em degradê) reaproveitado da
                divulgação do login do brindeme_sistema, para os logins de todos
                os painéis serem da mesma família. Diferente do painel anterior,
                aqui há texto de verdade — por isso não é `aria-hidden`. */}
            <section className="brand-panel">
                <div className="brand-copy">
                    <h2 data-in="1">
                        Seu catálogo <span>na frente de quem compra.</span>
                    </h2>
                    <p className="brand-lead" data-in="2">
                        Mantenha produtos, cores e estoque sempre atualizados e alcance
                        as lojas que vendem na plataforma Brinde.me. 💜
                    </p>
                </div>
            </section>
        </main>
    );
}

export default AuthTemplate;
